/**
 * Which tabs the Super Admin Escalations screen shows for a brand.
 *
 * Most ladders are on for every brand. A tab with `requiresFlag` is opt-in: it shows only
 * when that brand's feature flag is exactly `true` (the flags editor's "off unless
 * switched on" kind), so a journey built for one brand stays out of every other brand's
 * menu.
 */
export function visibleEscalationTabs(tabs, flags) {
  return tabs.filter((tab) => !tab.requiresFlag || flags?.[tab.requiresFlag] === true);
}
